import { CATEGORY_NAME_PREFIX } from "../../../i18n/i18n";

const getTranslationKeyByCategoryId = (categoryId: string) => ({ id: `${CATEGORY_NAME_PREFIX}.${categoryId}` });

export { getTranslationKeyByCategoryId };
